import { render, staticRenderFns } from "./BoletoCard.vue?vue&type=template&id=51d5824e&"
import script from "./BoletoCard.vue?vue&type=script&lang=js&"
export * from "./BoletoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports